export enum ContactsDrawerParams {
  ClaimSetNumber = 'claimSetNumber',
  ContactHolderId = 'contactHolderId',
  ContactHolder = 'contactHolder',
  ContactHolderName = 'contactHolderName',
  ReporterId = 'reporterId',
  Highlight = 'highlight',
  ClaimSetId = 'ClaimSetId',
  Claim = 'ClaimId',
  Policy = 'PolicyId',
  Coverage = 'CoverageId',
  Beneficiary = 'BeneficiaryId',
  HasBackButton = 'hasBackButton',
  BackButtonDestination = 'backButtonDestination',
}
